import {
  getValueDependingOnConsent,
  isConsentReadable,
} from "./getValueDependingOnConsent";
import { getSkin } from "../../../utils/getSkin";
import { TrackingBoolean } from "common-types";

import { OPTED_OUT_NUMBER, OPTED_OUT_STRING } from "../../consts";
import { getOperatingSystem, type OperatingSystem } from "../../../../device";
import { getBrowser } from "../../../../browser";

export function getSessionId(): string | undefined {
  return getValueDependingOnConsent(
    () => window.fandomContext?.tracking?.sessionId ?? "unknown",
    OPTED_OUT_STRING,
  );
}

export function getBeaconId(): string | undefined {
  return getValueDependingOnConsent(
    () => window.fandomContext?.tracking?.beaconId ?? "unknown",
    OPTED_OUT_STRING,
  );
}

export function getUserId(): number | undefined {
  return getValueDependingOnConsent(
    () =>
      window.fandomContext?.tracking?.userId ?? window.RLCONF?.wgUserId ?? 0,
    OPTED_OUT_NUMBER,
  );
}

export function getTrackingPv(): number {
  return window.fandomContext?.tracking?.pvNumber ?? -1;
}

export function getTrackingPvGlobal(): number {
  return window.fandomContext?.tracking?.pvNumberGlobal ?? -1;
}

export function getTrackingPvUid(): string {
  return window.fandomContext?.tracking?.pvUID ?? "unknown";
}

export function getTrackingPpid(): string {
  return window.fandomContext?.tracking?.ppid ?? "unknown";
}

export function getWikiId(): string | number {
  return (
    window.fandomContext?.site?.siteId ?? window.RLCONF?.wgCityId ?? "unknown"
  );
}

export function getWikiName(): string {
  return window.fandomContext?.site?.siteName ?? "unknown";
}

export function getPageLang(): string {
  return window.fandomContext?.page?.lang ?? "unknown";
}

export function getArticleId(): number {
  return window.fandomContext?.page?.articleId ?? -1;
}

export function getWikiSkin(): string {
  return getSkin(window.ads?.context?.platform ?? "unknown") ?? "unknown";
}

export function getWikiVertical(): string {
  return window.ads?.context?.targeting?.wikiVertical ?? "unknown";
}

export function getWikiPageType(): string {
  return window.ads?.context?.pageType ?? "unknown";
}

/**
 * Returns the opt-in status, when user explicitly opts-in in a
 * GDPR region, which requires an explicit signal. Assuming this
 * is an important enough signal which differentiates it from implicit CCPA opt-in.
 */
export function getOptIn(): TrackingBoolean {
  if (isConsentReadable("tcf")) {
    return window.fandomCmp?.optOut === false
      ? TrackingBoolean.YES
      : TrackingBoolean.NO;
  }

  return TrackingBoolean.NOT_APPLICABLE;
}

/**
 * Returns the opt-out status, when user explicitly opts-out in a
 * CCPA region after revisiting Fandom, which is implicitly opt-in by default on initial load.
 * Assuming this is an important enough signal which differentiates it from GDPR opt-out.
 */
export function getOptOutSale(): TrackingBoolean {
  if (isConsentReadable("usp")) {
    return window.fandomCmp?.optOut === true
      ? TrackingBoolean.YES
      : TrackingBoolean.NO;
  }

  return TrackingBoolean.NOT_APPLICABLE;
}

type OsAndBrowser = `${OperatingSystem} ${ReturnType<typeof getBrowser>}`;

export function getOSAndBrowser(): OsAndBrowser {
  return `${getOperatingSystem()} ${getBrowser()}`;
}
